type SvgConfig = {
  fill?: string
  size?: number
  rotate?: number
  border?: boolean
}

export function styledSvgIcon({ fill = 'purple', size = 18, rotate = 0, border }: SvgConfig = {}) {
  
if(rotate !== 90){

  return (

    
  <span>
    <svg width="46" height="47" fill={fill} viewBox="0 0 46 47" xmlns="http://www.w3.org/2000/svg" transform={`rotate(${rotate})`}>
      <circle id="border" cx="23.0354" cy="23.1866" r="22.8394" opacity="40%" display={border ? 'block' : 'none'}/>
      <circle cx="23.1039" cy="23.4419" r="11" transform="rotate(-90 23.1039 23.4419)" />
      <path d="M22.4156 17.2596L17.9087 21.9436C17.8418 22.0168 17.7967 22.1086 17.779 22.2079C17.7612 22.3072 17.7716 22.4097 17.8087 22.503C17.8459 22.5963 17.9083 22.6764 17.9884 22.7335C18.0685 22.7907 18.1628 22.8225 18.26 22.8251L20.2827 22.8251L20.2827 29.592C20.2827 29.729 20.335 29.8603 20.4282 29.9572C20.5214 30.054 20.6477 30.1084 20.7795 30.1084L24.7541 30.1084C24.8859 30.1084 25.0123 30.054 25.1054 29.9572C25.1986 29.8603 25.251 29.729 25.251 29.592L25.251 22.8251L27.2737 22.8251C27.5975 22.7628 27.7631 22.5907 27.7705 22.3087C27.7705 22.2409 27.7577 22.1737 27.7327 22.1111C27.7077 22.0485 27.6711 21.9916 27.6249 21.9436L23.1181 17.2596C23.0249 17.1628 22.8986 17.1084 22.7668 17.1084C22.6351 17.1084 22.5087 17.1628 22.4156 17.2596Z" fill="white"/>
    </svg>
  </span>
  )}
  else {
    
    return(
    <span>
      <svg width="46" height="47" viewBox="0 0 46 47" xmlns="http://www.w3.org/2000/svg" fill={fill}>
        <circle id="border" cx="23.0354" cy="23.1866" r="22.8394" opacity="40%" display={border ? 'block' : 'none'}/>
        <circle cx="23.1039" cy="23.4419" r="11"/>
        <rect x="17.1039" y="21.9419" width="12" height="3" rx="1.5" fill="white"/>
      </svg>
    </span>
 ) }
}

  

